import { render, staticRenderFns } from "./MobileLayout.vue?vue&type=template&id=5bb09585&scoped=true"
import script from "./MobileLayout.vue?vue&type=script&lang=ts"
export * from "./MobileLayout.vue?vue&type=script&lang=ts"
import style0 from "./MobileLayout.vue?vue&type=style&index=0&id=5bb09585&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb09585",
  null
  
)

export default component.exports